import React, { useState } from "react";
import cookie from "js-cookie";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../../partials/aside/Sidebar";
import StepsAddCampaigns from "../../../StepsAddCampaigns";
import AddGroupSitePublisher from "../../../../publisher/coworker/AddCategoryUserSitePublisher";
import actionCookie from "../../../../../../helpers/action-cookie";
import TitleBar from "../../../../../partials/content/TitleBar";

function AddGroupSitePublisherContainerCampaignBanner() {
  const params = useParams();
  const userID = params.id;

  cookie.set(
    actionCookie.REF_ENTER_ADD_GROUP_SITE_PUBLISHER,
    actionCookie.REF_ENTER_ADD_GROUP_SITE_PUBLISHER_VALUE_ADD_CAMPAIGN
  );

  const previousPageUrl = cookie.get(actionCookie.PREVIOUS_PAGE_URL);
  const checkPreviousPageUrlIsAllPageSitePublishers = () => {
    if (
      previousPageUrl.includes("/publishers/") &&
      previousPageUrl.includes("/all-page")
    ) {
      return true;
    }
    return false;
  };

  const [showAddGroupSitePublisher, setShowAddGroupSitePublisher] = useState(
    () => {
      if (checkPreviousPageUrlIsAllPageSitePublishers()) {
        return true;
      }
      return false;
    }
  );

  let items = [
    {
      title: "نوع کمپین",
      status: true,
      link: "/campaigns/coworker/all-type/" + userID,
    },
    {
      title: "نوع کمپین بنری",
      status: true,
      link: "/campaigns/coworker/all-type-banner/" + userID,
    },
    {
      title: "کمپین بنری",
      status: false,
      link: "/campaigns/banner/simple/add",
    },
    {
      title: "تبلیغ بنری",
      status: false,
      link: "/campaigns/banner/add-simple",
    },
  ];
  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="گروه  نمایش دهنده بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <StepsAddCampaigns items={items} />

              {showAddGroupSitePublisher === false ? (
                <>
                  <div className="alert alert-secondary">
                    <div className="text-center pb-2 white-space-nowrap">
                      آیا از قبل گروه نمایش دهنده ساخته اید؟{" "}
                    </div>
                    <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center">
                      <span className="py-2 py-lg-0 pl-0 pl-lg-2">
                        <Link
                          to={`/campaigns/coworker/banner/simple/add/${userID}`}
                          className="text-decoration-none "
                        >
                          <button className="btn btn-success  ">
                            بله , ادامه بده
                          </button>
                        </Link>
                      </span>
                      <span>
                        <button
                          type="button"
                          class="btn btn-danger"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowAddGroupSitePublisher(true);
                          }}
                        >
                          خیر , الان بساز
                        </button>
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}

              {showAddGroupSitePublisher === true ? (
                <>
                  <AddGroupSitePublisher />
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default AddGroupSitePublisherContainerCampaignBanner;
